import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { MapPin, CalendarBlank, Clock, ShieldCheck } from "@phosphor-icons/react";
import { Logo, PageLoader, StatusBadge } from "../components/shared";
import axios from "axios";
import { API } from "../lib/api";

function fmtDate(d) {
  if (!d) return "TBA";
  try { return new Date(d).toLocaleDateString("en-IN", { weekday: "long", day: "numeric", month: "long", year: "numeric" }); }
  catch { return d; }
}

export default function PublicTicket() {
  const { token } = useParams();
  const [t, setT] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(false);

  useEffect(() => {
    axios.get(`${API}/t/${token}`).then((r) => setT(r.data)).catch(() => setErr(true)).finally(() => setLoading(false));
  }, [token]);

  if (loading) return <div className="min-h-screen grid place-items-center"><PageLoader /></div>;
  if (err || !t) return (
    <div className="min-h-screen grid place-items-center px-6 text-center">
      <div><Logo /><p className="mt-4 text-muted-foreground">This ticket link is invalid or has expired.</p></div>
    </div>
  );

  return (
    <div className="min-h-screen bg-muted/40 grid place-items-center p-4">
      <div className="w-full max-w-sm rounded-2xl border border-border bg-card overflow-hidden shadow-xl" data-testid="public-ticket">
        <div className="bg-foreground text-background p-5 flex items-center justify-between">
          <Logo dark />
          <span className="text-xs text-background/60">Shared ticket</span>
        </div>
        <div className="p-5">
          <div className="text-xs uppercase tracking-widest text-primary font-bold">{t.category}</div>
          <div className="font-heading text-xl font-semibold tracking-tight">{t.event_title}</div>
          <div className="text-sm text-muted-foreground">{t.occurrence_label}</div>
        </div>
        <div className="px-6 pb-2 grid place-items-center">
          <img src={t.qr} alt="QR ticket" className="w-56 h-56" />
          <div className="font-mono text-base mt-2">{t.code}</div>
          <div className="mt-2"><StatusBadge status={t.checked_in ? "verified" : t.status} /></div>
        </div>
        <div className="p-5 space-y-2 text-sm">
          <div className="flex items-center gap-2 text-muted-foreground"><CalendarBlank size={15} className="text-primary" /> {fmtDate(t.show_date)}</div>
          <div className="flex items-center gap-2 text-muted-foreground"><Clock size={15} className="text-primary" /> {t.show_time || "TBA"}</div>
          <div className="flex items-center gap-2 text-muted-foreground"><MapPin size={15} className="text-primary" /> {t.venue}, {t.city}</div>
          {t.access_checkpoints?.length > 0 && (
            <div className="pt-1">
              <div className="text-xs uppercase tracking-widest text-muted-foreground mb-1.5 flex items-center gap-1"><ShieldCheck size={13} /> Access</div>
              <div className="flex flex-wrap gap-1.5">
                {t.access_checkpoints.map((c, i) => <span key={i} className="px-2.5 py-1 rounded-full bg-emerald-100 text-emerald-800 text-xs font-semibold">{c}</span>)}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
